module.exports = __webpack_public_path__ + "static/img/PGE_ipl.2c3694a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/PGE_ipl.gif
// module id = aiR6
// module chunks = 0